import { render, staticRenderFns } from "./stream-type.vue?vue&type=template&id=765f0945&scoped=true"
import script from "./stream-type.vue?vue&type=script&lang=js"
export * from "./stream-type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765f0945",
  null
  
)

export default component.exports